import { apiClient } from "helpers/api_helper";

export const getAllProductData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/ProductDetails/GetSNMCCAndNonSNMCCProductHeaders`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const importProductHeader = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/ProductDetails/ImportProductHeader', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const importProductDetails = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/ProductDetails/ImportProductDetails', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};